var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "open-app-container" }, [
    _c("div", { staticClass: "logo" }),
    _vm._v(" "),
    _c("p", { staticClass: "solgan" }, [_vm._v("走近数字世界中的上市公司")]),
    _vm._v(" "),
    _c("img", {
      staticClass: "app-poster",
      attrs: { src: require("@/assets/images/app.png"), width: "100%" }
    }),
    _vm._v(" "),
    _c(
      "button",
      { staticClass: "download-button", on: { click: _vm.downloadApp } },
      [_vm._v("下载APP")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "open-app", on: { click: _vm.openApp } }, [
      _vm._v("打开APP")
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "company" }, [_vm._v("汇金智通")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }